import { Component, Event, EventEmitter, h, Prop, State } from '@stencil/core';
import clsx from 'clsx';

@Component({
  tag: 'drag-and-drop-component',
  scoped: true,
  styleUrls: ['drag-and-drop-component.scss'],
  assetsDirs: ['assets'],
})
export class DragAndDropZone {
  @Prop() buttontext: string;
  @Prop() instruction: string;
  @Event({ eventName: 'fileChanged', bubbles: true }) fileChanged: EventEmitter<File | undefined>;
  @State() isDraggedOver = false;
  @Prop() files: File[] = [];
  @State() dragCounter = 0;
  @Prop() isLoading = false;
  @Prop() isError = false;
  @State() isMobile = true;
  @Prop() errorMessage = '';

  componentDidLoad() {
    window.addEventListener('resize', this.checkIfMobile);
    this.checkIfMobile();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.checkIfMobile);
  }

  checkIfMobile = () => {
    const mobile = window.innerWidth <= 660;
    if (this.isMobile !== mobile) {
      this.isMobile = mobile;
    }
  };

  handleDragEnter = (event: DragEvent) => {
    event.preventDefault();
    this.dragCounter++;
    if (this.dragCounter > 0) {
      this.isDraggedOver = true;
    }
  };

  handleDragLeave = (event: DragEvent) => {
    event.preventDefault();
    this.dragCounter--;
    if (this.dragCounter === 0) {
      this.isDraggedOver = false;
    }
  };

  handleDrop = (event: DragEvent) => {
    event.preventDefault();
    this.dragCounter = 0;
    this.isDraggedOver = false;
    const droppedFiles = event.dataTransfer?.files;
    if (droppedFiles && droppedFiles.length) {
      this.files = [droppedFiles.item(0)];
      this.fileChanged.emit(droppedFiles.item(0));
    }
  };

  onClickFileUploadButton = () => {
    const fileInput = document.getElementById('__FILE__');
    if (fileInput) {
      fileInput.click();
    }
  };

  onRemoveFile = () => {
    this.files = [];
    this.fileChanged.emit(undefined);
  };

  handleChange(e: Event) {
    const files = e.target['files'];
    this.files = [...(files || [])];
    const fileToEmit = files && files.length > 0 ? files[0] : undefined;
    this.fileChanged.emit(fileToEmit);
  }
  

  render() {
    return (
      <div>
        {this.isMobile ? (
          this.files.length === 0 || this.isError ? (
            <div>
              <div>
                <theme-button
                  onPress={this.onClickFileUploadButton}
                  isError={this.isError}
                  class={clsx([this.isError && 'error-button'])}
                >
                  <div class="button-content">
                    <svg class={clsx(['icon', this.isError && 'error-button'])} version="1.1" id="Layer_1" viewBox="0 0 512 512">
                      <path
                        d="M470.7,277.2c3-11.2,4.7-22.9,4.7-35c0-75.8-61.4-137.1-137.1-137.1c-19.5,0-38,4.1-54.7,11.4
                c-16.8-39-55.6-66.3-100.7-66.3c-60.6,0-109.7,49.1-109.7,109.7c0,4.1,0.8,7.9,1.2,11.9C30.5,192.1,0,236.3,0,287.9
                c0,70.7,57.3,128,128,128h310.9c40.4,0,73.1-32.7,73.1-73.1C512,313.8,495.1,289.1,470.7,277.2z M292.6,251.3v91.4h-73.1v-91.4
                h-54.9l91.4-91.4l91.4,91.4H292.6z"
                      />
                    </svg>
                    <span class={clsx([this.isError && 'error-button'])}>{this.buttontext}</span>
                  </div>
                </theme-button>
                <input type="file" id="__FILE__" class={'hidden'} onChange={e => this.handleChange(e)} />
              </div>
              {this.isError && (
                <div class="error-container">
                  <div class="material-icons error-icon">error</div>
                  <p class="error-text">{this.errorMessage}</p>
                </div>
              )}
            </div>
          ) : (
            <div class={'file-previewer'}>
              <div class="title">
                {this.isLoading ? (
                  <loading-spinner />
                ) : (
                  <svg class={'icon'} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.34183 1.66663L3.3335 18.3333H16.6668V6.66663L11.6668 1.66663H3.34183ZM10.8335 7.49996V2.91663L15.4168 7.49996H10.8335Z" />
                  </svg>
                )}
                <p class="file-name">{this.files[0].name}</p>
              </div>
              {!this.isLoading && (
                <div class="material-icons close-button" onClick={this.onRemoveFile}>
                  delete
                </div>
              )}
            </div>
          )

        ) : (
          <div>
            {this.files.length === 0 || this.isError ? (
              <div class="container">
                <div
                  class={clsx(['drag-and-drop-zone', this.isDraggedOver && 'dragzone-hovered-over', this.isError && 'error'])}
                  onDragOver={e => e.preventDefault()}
                  onDragEnter={this.handleDragEnter}
                  onDragLeave={this.handleDragLeave}
                  onDrop={this.handleDrop}
                >
                  <theme-button
                    onPress={this.onClickFileUploadButton}
                    isError={this.isError}
                    class={clsx([this.isError && 'error-button'])}
                  >
                    <div class="button-content">
                      <svg class={clsx(['icon', this.isError && 'error-button'])} version="1.1" id="Layer_1" viewBox="0 0 512 512">
                        <path
                          d="M470.7,277.2c3-11.2,4.7-22.9,4.7-35c0-75.8-61.4-137.1-137.1-137.1c-19.5,0-38,4.1-54.7,11.4
                        c-16.8-39-55.6-66.3-100.7-66.3c-60.6,0-109.7,49.1-109.7,109.7c0,4.1,0.8,7.9,1.2,11.9C30.5,192.1,0,236.3,0,287.9
                        c0,70.7,57.3,128,128,128h310.9c40.4,0,73.1-32.7,73.1-73.1C512,313.8,495.1,289.1,470.7,277.2z M292.6,251.3v91.4h-73.1v-91.4
                        h-54.9l91.4-91.4l91.4,91.4H292.6z"
                        />
                      </svg>
                      <span class={clsx([this.isError && 'error-button'])}>{this.buttontext}</span>
                    </div>
                  </theme-button>
                  <p class={clsx(['instruction-text', this.isError && 'error-text'])}>{this.instruction}</p>
                  <input type="file" id="__FILE__" class={'hidden'} onChange={e => this.handleChange(e)} />
                </div>
                {this.isError && (
                  <div class="error-container">
                    <div class="material-icons error-icon">error</div>
                    <p class="error-text">{this.errorMessage}</p>
                  </div>
                )}
              </div>
            ) : (
              <div class={'file-previewer'}>
                <div class="title">
                  {this.isLoading ? (
                    <loading-spinner />
                  ) : (
                    <svg class={'icon'} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.34183 1.66663L3.3335 18.3333H16.6668V6.66663L11.6668 1.66663H3.34183ZM10.8335 7.49996V2.91663L15.4168 7.49996H10.8335Z" />
                    </svg>
                  )}
                  <p class="file-name">{this.files[0].name}</p>
                </div>
                {!this.isLoading && (
                  <div class="material-icons close-button" onClick={this.onRemoveFile}>
                    delete
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

